import { render } from "./PolicySuccessPage.vue?vue&type=template&id=1c4367e6"
import script from "./PolicySuccessPage.vue?vue&type=script&lang=js"
export * from "./PolicySuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__